import { DateTimePicker as MantineDateTimePicker, DateTimePickerProps as MantineDateTimePickerProps } from '@mantine/dates';
import { useMemo, useState } from 'react';

interface DateTimePickerInputProps extends MantineDateTimePickerProps {
  badgeMessage?: string;
  badgeIcon?: string;
  'data-pw'?: string;
}

export const DateTimePickerInput: React.FC<DateTimePickerInputProps> = (props) => {
  const [focused, setFocused] = useState(false);

  const floating = useMemo(() => {
    return !!props.value || focused ? true : undefined;
  }, [props.value, focused]);

  const handleFocus = (evt) => {
    setFocused(true);
    props.onFocus?.(evt);
  };

  const handleBlur = (evt) => {
    setFocused(false);
    props.onBlur?.(evt);
  };

  return (
    <MantineDateTimePicker
      data-pw={props['data-pw']}
      {...(props as any)}
      onFocus={handleFocus}
      onBlur={handleBlur}
      data-floating={floating}
      labelProps={{ ...props.labelProps, 'data-floating': floating, 'data-error': props.error }}
    />
  );
};
